import type { BrandConfig } from '@denqfabrik/landing-ui';
import { legalEntity } from './legal';

const brandConfig: BrandConfig = {
  name: 'Denqfabrik',
  siteName: 'Denqfabrik',
  baseUrl: 'https://denqfabrik.com',
  gtm: { id: import.meta.env.VITE_GTM_ID ?? '' },

  structuredData: {
    // This is the Organization JSON-LD description that actually ships: measured on the
    // running app 2026-08-17, both /de and /en serve THIS string. The per-language
    // `structuredData` blocks in the i18n bundles reach nothing today (their only
    // consumer, an app-local SeoHead, does not exist — see the report).
    description:
      'Denqfabrik builds, tests and operates integrations between shop, ERP and marketplace for retail and e-commerce teams — plus AI agents with safety architecture, guardrails, and audit trails.',
    foundingLocation: 'Seelze',
    sameAs: ['https://www.linkedin.com/company/denqfabrik', 'https://github.com/denqfabrik'],
    contactEmail: legalEntity.email,
    knowsAbout: [
      'AI Agent Development',
      'AI Safety and Guardrails',
      'Commerce Operations Automation',
      'Enterprise AI Architecture',
      'EU AI Act Compliance',
      'LLM-based Systems',
      'Out-of-Distribution Detection',
    ],
  },
};

export default brandConfig;
